import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export function useRoadmapImageSrc(imageId, defaultUrl) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!imageId) { setSrc(defaultUrl || null); return undefined; }
    let url = null;
    api.get(`/roadmap-images/${imageId}/file`, { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => setSrc(null));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [imageId, defaultUrl]);
  return src;
}

export function ProgramRoadmapImage({ data, fallback = null }) {
  const src = useRoadmapImageSrc(data?.image_id, data?.default_url);
  if (!data?.program_key) return <Message text="Your program roadmap will appear here once your program is assigned." />;
  if (!src) return fallback || <Message text={`The ${data.program_label} roadmap hasn't been added yet. Your district team will add it soon.`} />;
  return (
    <figure className="rounded-2xl border border-slate-200 bg-white p-3" data-testid="journey-roadmap-image">
      <a href={src} target="_blank" rel="noreferrer" className="block"><img src={src} alt={`${data.program_label} roadmap`} className="block w-full h-auto object-contain" /></a>
      <figcaption className="text-xs text-slate-500 mt-2">{data.program_label} roadmap · tap to open full size</figcaption>
    </figure>
  );
}

const Message = ({ text }) => (
  <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-8 text-center" data-testid="portal-roadmap-empty"><p className="text-sm text-slate-500">{text}</p></div>
);
